import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { clientLogin } from "../../api/clientAuthApi";
import { ClientAuthProvider, useClientAuth } from "../../auth/ClientAuthProvider";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";
import {
  CASAMAPA_ADMIN_PORTAL_BASE,
  MIDPOINT_MEDIA_ADMIN_PORTAL_BASE,
} from "../../constants/clientAdminPortalRoutes";

const ClientLoginForm = () => {
  const navigate = useNavigate();
  const { isAuthenticated, refresh } = useClientAuth();
  const paths = useClientPortalPaths();
  const isCasaMapaPortal = paths.base === CASAMAPA_ADMIN_PORTAL_BASE;
  const isMidpointMediaPortal = paths.base === MIDPOINT_MEDIA_ADMIN_PORTAL_BASE;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (isAuthenticated) {
    return <Navigate to={paths.dashboard} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSubmitting(true);
    try {
      await clientLogin(email, password);
      await refresh();
      navigate(paths.dashboard);
    } catch (error) {
      setErrorMessage(error.message || "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="midpoint-app auth-page account-area-app">
      <section className="panel-card auth-card">
        <p className="eyebrow">
          {isCasaMapaPortal
            ? "CasaMapa admin"
            : isMidpointMediaPortal
              ? "Midpoint Media operations"
              : "Client portal"}
        </p>
        <h1>Sign in</h1>
        <p className="muted">
          {isCasaMapaPortal
            ? "Manage CasaMapa content, leads, and publishing"
            : isMidpointMediaPortal
              ? "CRM, people, infrastructure, and OpenProject for Midpoint Media"
              : "Manage your assigned Client Views and community content"}
        </p>
        <form onSubmit={handleSubmit}>
          <label className="admin-users-field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </label>
          <label className="admin-users-field">
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
          <button type="submit" className="midpoint-share-button" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="muted">
          <Link to={isCasaMapaPortal ? "/v/casamapa" : isMidpointMediaPortal ? "/v/midpoint-media" : "/"}>
            {isCasaMapaPortal
              ? "Back to CasaMapa"
              : isMidpointMediaPortal
                ? "Back to Midpoint Media"
                : "Back to map"}
          </Link>
        </p>
      </section>
    </div>
  );
};

const ClientLoginPage = () => (
  <ClientAuthProvider>
    <ClientLoginForm />
  </ClientAuthProvider>
);

export default ClientLoginPage;
